import React from 'react';
var useState = React.useState;
export function useForceUpdate() {
    var _a = useState(true), value = _a[0], set = _a[1]; // boolean state
    return function () { return set(!value); }; // toggle the state to force render
}
